import React, { useState } from 'react';
import { Button, Form, Modal, Select } from 'antd';

import { useChangeConsultantRefMutation } from 'app/services/edpApiV1/references';
import { useSubordinatesQuery } from 'app/services/edpApiV1/viewer';

import { useNotifications } from 'shared/hooks/use-notifications';
import { getErrorText } from 'shared/helpers/utils';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  requestId: number;
  referenceHrId?: number | null;
};

const ReferencesModalVacationsSubordinates = ({ openModal, setOpenModal, requestId, referenceHrId }: TProps) => {
  const [btnState, setBtnState] = useState<boolean>(true);
  const [form] = Form.useForm();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [changeConsultantTrigger, result] = useChangeConsultantRefMutation();

  const { data: allSubordinates } = useSubordinatesQuery({ include: 'me' });
  const { isSuccess, isError, reset, error: errorData } = result;

  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
    form.resetFields();
    setBtnState(true);
  };

  const onSelect = (consultantId: number) => {
    setBtnState(false);
    if (consultantId === referenceHrId) setBtnState(true);
  };

  const onFinish = (values: { consultantId: number }) => {
    const { consultantId } = values;
    const bodyRequest = {
      requestId,
      hrId: consultantId,
      allAvailableOrganizations,
    };
    changeConsultantTrigger(bodyRequest);
    setOpenModal(false);
    form.resetFields();
    setBtnState(true);
  };

  useNotifications(isSuccess, isError, 'Ответственный назначен', getErrorText(errorData), reset);

  return (
    <Modal
      title="Выберите ответственного сотрудника"
      footer={false}
      onOk={handleOk}
      onCancel={handleCancel}
      visible={openModal}
    >
      <Form form={form} name="rejectionForm" onFinish={onFinish}>
        <Form.Item
          name="consultantId"
          rules={[
            {
              validator: async (_, v) => {
                if (v === referenceHrId) return Promise.reject();
              },
              message: 'Выберите нового ответственного',
            },
          ]}
        >
          {allSubordinates && (
            <Select placeholder="Выберите из списка" onSelect={onSelect}>
              {allSubordinates.map(({ id, name, middleName, lastName }) => (
                <Select.Option key={id} value={id}>
                  {`${lastName} ${name} ${middleName ?? ''}`}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" type="primary" disabled={btnState}>
            Назначить
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReferencesModalVacationsSubordinates;
